import LoadingAnimation from "@/components/LottieAnimations/Loading/LoadingAnimation";
import SendLetterAnimation from "@/components/LottieAnimations/SendLetter/SendLetterAnimation";
import i18n from "@/i18n";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import classNames from "classnames";
import { useEffect, useState } from "react";
import "./IndefiniteModal.scss";
import SuccessModal from "./SuccessModal";

const ANIMATION_STYLE = {
  height: 200,
  width: 300,
};
const ANIMATION_STYLE_LOADER = {
  height: 200,
  width: 150,
};

export type IndefiniteAnimationType = "letter" | "loading";
interface IndefiniteModalProps {
  animationType: IndefiniteAnimationType;
  loadingText?: React.ReactNode;

  title?: string;
  successMessage: string;
  promise: () => Promise<any>;

  onSuccess: (result: any) => Promise<void>;
  onError: (error: any) => void;
}
const IndefiniteModal = (props: IndefiniteModalProps) => {
  const [status, setStatus] = useState<"loading" | "success">("loading");
  const [result, setResult] = useState<any>(null);
  const animationType = props.animationType || "loading";

  useEffect(() => {
    setStatus("loading");
    props
      .promise()
      .then((result) => {
        setResult(result);
        setStatus("success");
      })
      .catch((error) => {
        props.onError(error);
      });
  }, []);
  return (
    <div className={classNames(`progress-modal`)}>
      {status === "loading" && (
        <>
          <div className={`animation-container`}>
            {animationType === "loading" && (
              <LoadingAnimation style={ANIMATION_STYLE_LOADER} />
            )}
            {animationType === "letter" && (
              <SendLetterAnimation style={ANIMATION_STYLE_LOADER} />
            )}
          </div>
          <div className={`info`}>
            {props.loadingText ? (
              props.loadingText
            ) : (
              <>
                {i18n.t(
                  "ProgressModal.DescriptionLine1",
                  "Bitte haben Sie einen Moment Geduld."
                )}
              </>
            )}
          </div>
        </>
      )}
      {status === "success" && (
        <>
          <SuccessModal message={props.successMessage} title={props.title} />
          <div className={`__flex __justify-end padding-top-10`}>
            <BFButton
              appearance="primary"
              onClick={async () => await props.onSuccess(result)}
            >
              {i18n.t("Global.Buttons.Ok")}
            </BFButton>
          </div>
        </>
      )}
    </div>
  );
};

export default IndefiniteModal;
